<button type="button" status="control" nbButton (click)="openChooseCatalogModal()" size="small">
  <nb-icon icon="list-outline"/>
</button>
